import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EnrichedLeadsState {
  pageNumber: number;
  pageSize: number;
  searchInput: string;
  linkStatus: string;
}

export const initialState: EnrichedLeadsState = {
  pageNumber: 1,
  pageSize: 15,
  searchInput: '',
  linkStatus: '',
};

export const enrichedLeadsSlice = createSlice({
  name: 'enrichedLeads',
  initialState,
  reducers: {
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    setSearchInput: (state, action: PayloadAction<string>) => {
      state.searchInput = action.payload;
      state.pageNumber = 1;
    },
    setLinkStatus: (state, action: PayloadAction<string>) => {
      state.linkStatus = action.payload;
      state.pageNumber = 1;
    },
    resetEnrichedLeadsFilters: () => initialState,
  },
});

export const {
  setPageNumber,
  setSearchInput,
  setLinkStatus,
  resetEnrichedLeadsFilters,
} = enrichedLeadsSlice.actions;

export default enrichedLeadsSlice;
